import React from "react";

// The server's consent copy carries **bold** and [text](url). Nodes, not HTML —
// nothing here is ever injected as markup. `exec` over `matchAll`: carriers
// open this on whatever phone they have.
const MARKUP = "\\*\\*(.+?)\\*\\*|\\[(.+?)\\]\\((https?://[^\\s)]+)\\)";

// `strongAs(text, key)` may return a node to use for a **bold** run instead.
export function renderMarkup(text, linkClassName = "", strongAs) {
  const re = new RegExp(MARKUP, "g");
  const out = [];
  let last = 0;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(
      m[1] !== undefined ? (
        strongAs?.(m[1], m.index) || (
          <strong key={m.index} className="font-semibold">
            {m[1]}
          </strong>
        )
      ) : (
        <a
          key={m.index}
          href={m[3]}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className={`font-[inherit] font-medium underline underline-offset-2 ${linkClassName}`}
        >
          {m[2]}
        </a>
      ),
    );
    last = m.index + m[0].length;
  }
  out.push(text.slice(last));
  return out;
}
